function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
/** Tab.Item */

var TabItem = /*#__PURE__*/function (_React$Component) {
  _inherits(TabItem, _React$Component);

  var _super = _createSuper(TabItem);

  function TabItem() {
    _classCallCheck(this, TabItem);

    return _super.apply(this, arguments);
  }

  _createClass(TabItem, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          prefix = _this$props.prefix,
          active = _this$props.active,
          lazyLoad = _this$props.lazyLoad,
          unmountInactiveTabs = _this$props.unmountInactiveTabs,
          children = _this$props.children;
      this._actived = this._actived || active;

      if (lazyLoad && !this._actived) {
        return null;
      }

      if (unmountInactiveTabs && !active) {
        return null;
      }

      var cls = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefix, "tabs-tabpane"), true), _defineProperty(_classnames, "".concat(active ? 'active' : 'hidden'), true), _classnames));
      return /*#__PURE__*/React.createElement("div", {
        role: "tabpanel",
        "aria-hidden": active ? 'false' : 'true',
        className: cls
      }, children);
    }
  }]);

  return TabItem;
}(React.Component);

_defineProperty(TabItem, "propTypes", {
  prefix: PropTypes.string,

  /**
   * 选项卡标题
   */
  title: PropTypes.node,

  /**
   * 单个选项卡是否可关闭
   */
  closeable: PropTypes.bool,

  /**
   * 选项卡徽标
   */
  badge: PropTypes.node,

  /**
   * 选项卡是否被禁用
   */
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  lazyLoad: PropTypes.bool,
  unmountInactiveTabs: PropTypes.bool,
  children: PropTypes.any
});

_defineProperty(TabItem, "defaultProps", {
  prefix: 'next-',
  closeable: false
});

export default TabItem;